/*============================================================================
    Sticky Add to Cart
  ==============================================================================*/
theme.StickyAddToCartJL = (function () {
  var stickyAddToCart = document.getElementById('stickyAddToCart');
  var stickyAddToCartButton = document.getElementById('stickyAddToCartButton');
  var addToCartButton = document.getElementsByClassName('payment-buttons ')[0];
  var form_id = document.getElementById('stickyMainFormId').value;
  var form = document.getElementById(form_id);

  if (addToCartButton) {
    var addToCartButtonOffsetTop = addToCartButton.offsetTop;
    var addToCartButtonHeight = addToCartButton.offsetHeight;

    window.addEventListener('scroll', function() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var showStickyButton = scrollTop > (addToCartButtonOffsetTop + addToCartButtonHeight);

      if (showStickyButton) {
        stickyAddToCart.style.display = 'block';
        document.body.classList.add('sticky-atc');
      } else {
        stickyAddToCart.style.display = 'none';
        document.body.classList.remove('sticky-atc');
      }
    });

    stickyAddToCartButton.addEventListener('click', function(e) {
      form.dispatchEvent(new Event('submit'));
      e.preventDefault();
    });
  }
});

DOMready(function(){
  theme.StickyAddToCartJL();
});